import React, {useEffect, useState} from 'react'
import './GameBrief.scss'
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {EditGame} from '../../CompanyComponents';
import {openDialog} from '../../../slices/dialog';
import ButtonCircle from '../../Common/ButtonCircle';
import {isExpired} from '../../../helpers/misc';
import {useHistory} from 'react-router';
import {selectSelectedRm, storeSelectedGame} from '../../../slices/selected';
import {deleteGame, notifyGameTarget} from '../../../api/game';
import {openAlert} from '../../../slices/alert';
import {ConfirmAction} from '../../CommonComponents';
import {useTranslation} from 'react-i18next';
import NotificationsIcon from '@material-ui/icons/Notifications';
import {finishFullScreenLoading, startFullScreenLoading} from '../../../slices/loading';
import {selectUser} from '../../../slices/profile';
import {gameRequests, ROUTES} from '../../../db/models/const';

const CardRmGameBrief = ({game, onPress = null, editable, goTo}) => {
    const dispatch = useDispatch();
    const title = game?.title || "";
    const [request, setRequest] = useState();
    const task = game?.task || "";
    const target = game?.target || "";
    const {t} = useTranslation();
    const duration = game?.deadline ? moment(game.deadline.seconds * 1000).format("DD-MM-YYYY") : t("company_rm_game_durationDays", {days: game?.durationDays});
    const history = useHistory();
    const user = useSelector(selectUser);
    const studentGames = user?.games || [];
    const studentWins = user?.wins || [];
    const [attendance, setAttendance] = useState();
    const rm = useSelector(selectSelectedRm);

    useEffect(() => {
        if (!game) return;

        const request = gameRequests.find(request => request.id === game.request);
        setRequest(t(request?.label));
    }, [game])

    useEffect(() => {
        const attended = studentGames.map(g => g.id).includes(game.id);
        if (!attended)
            setAttendance("");

        else {
            if (studentWins.find(sw => sw.gameId === game.id))
                setAttendance("Game vinto");
            else {
                setAttendance("Progetto inviato");
            }
        }
    }, [game, studentGames]);

    const onGameClick = () => {
        if (!game) return;
        dispatch(storeSelectedGame({game}));
        history.push(ROUTES.COMPANY_GAME);
    }

    const onEditClick = (e, game) => {
        e.stopPropagation();

        dispatch(openDialog({
            Content: EditGame,
            title: t("company_rm_editGame_title"),
            props: {game},
            closable: true
        }));
    };

    // useEffect(() => {
    //     if (role === "student") {
    //         const unsubscribe = getSubmissionListener({
    //             next: (doc) => {
    //                 let submission = doc.data();
    //                 setSubmission(submission);
    //             },
    //         }, game.id, uid);
    //         return unsubscribe;
    //     }
    // }, [])

    // const onSubmitClick = game => {
    //     dispatch(openDialog({
    //         Content: SubmitGame,
    //         title: "Submit",
    //         props: { game },
    //         closable: true
    //     }));
    // }

    // const onAttachmentClick = (e, url) => {
    //     if (!url) return;
    //     e.stopPropagation();
    //     window.open(url, '_blank');
    // }

    // const onAttachmentDeleteClick = id => {
    //     deleteFile(`${uid}/games/${game.id}/attachments/${id}`, `attachments.${id}`, `${Collections.GAMES}/${game.id}`);
    // }

    // const onSubmissionDeleteClick = id => {
    //     deleteFile(`${game.companyId}/games/${game.id}/submissions/${uid}/${id}`, `files.${id}`, `${Collections.GAMES}/${game.id}/${Collections.SUBMISSIONS}/${submission.studentId}`);
    // }

    const onDeleteClick = (event, gameId) => {
        event.stopPropagation();

        if (!gameId) return;

        const action = () => {
            deleteGame(gameId).then(() => {
                dispatch(openAlert({type: "info", message: t("alert_game_deleted")}));
            }).catch((error) => {
                console.error(error)
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            })
        }

        dispatch(openDialog({
            Content: ConfirmAction,
            title: "Stai per cancellare il Game",
            props: {
                action
            },
            closable: true
        }))
    }

    return (
        <div className={`card card--clickable cardRmGameBrief ${isExpired(game.deadline) ? "expired" : ""}`}
             onClick={() => onGameClick()}>
            <div className="card__header border">
                <div className="cardRmGameBrief__headerTop">
                    <h2>{title}</h2>
                    {editable && <div className="actions">
                        <ButtonCircle onClick={(e) => onEditClick(e, game)}><EditIcon/></ButtonCircle>
                        <ButtonCircle onClick={(e) => onDeleteClick(e, game.id)}><DeleteIcon/></ButtonCircle>
                    </div>}
                </div>
                {game?.notifiedAt?.seconds !== 0 &&
                    <p className="cardRmGameBrief__notificationDate">{t("company_rm_games_notifiedAt") + moment(game.notifiedAt.seconds * 1000).format("DD-MM-YYYY")}</p>}
            </div>
            <div className="card__content">
                {target && rm?.groups[target]?.name && editable && <div className="item">
                    <label>{t("company_rm_games_target_label")}</label>
                    <p>{rm.groups[target].name}</p>
                </div>}
                <div className="item">
                    <label>{t("company_rm_games_request_label")}</label>
                    <p>{request}</p>
                </div>
                <div className="item">
                    <label>{t("company_rm_games_task_label")}</label>
                    <p>{task}</p>
                </div>
                <div className="item">
                    <label>{t("company_rm_games_duration_label")}</label>
                    <p>{duration}</p>
                </div>
                <div className="attendance">
                    {attendance}
                </div>
            </div>
        </div>
    )
}

export default CardRmGameBrief
